(() => {
  if(document.body.classList.contains('edibot-landing-page')){
    const unrelatedPopupSelector='[role="dialog"][aria-modal="true"][aria-label="POPUP Form"][data-kl-scroll-locking-modal="true"]:has(form[data-testid="klaviyo-form-X83Yrp"])';
    const closeAttempted=new Set();
    let popupCheckScheduled=false;
    const popupIsOpen=dialog=>dialog.isConnected&&!dialog.hidden&&dialog.getAttribute('aria-hidden')!=='true'&&dialog.style.visibility!=='hidden'&&dialog.getClientRects().length>0&&(!dialog.parentElement||getComputedStyle(dialog.parentElement).visibility!=='hidden');
    function closeUnrelatedPopup(){
      popupCheckScheduled=false;
      closeAttempted.forEach(dialog=>{if(!popupIsOpen(dialog))closeAttempted.delete(dialog);});
      document.querySelectorAll(unrelatedPopupSelector).forEach(dialog=>{
        if(closeAttempted.has(dialog)||!popupIsOpen(dialog))return;
        const closeButton=dialog.querySelector('button.klaviyo-close-form[aria-label="Close dialog"]');
        if(!closeButton||closeButton.disabled)return;
        closeAttempted.add(dialog);
        closeButton.click();
      });
    }
    const unrelatedPopupObserver=new MutationObserver(records=>{
      records.forEach(record=>record.removedNodes.forEach(node=>{
        closeAttempted.forEach(dialog=>{if(node===dialog||node.contains?.(dialog))closeAttempted.delete(dialog);});
      }));
      if(!popupCheckScheduled){popupCheckScheduled=true;requestAnimationFrame(closeUnrelatedPopup);}
    });
    unrelatedPopupObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','aria-hidden','aria-modal','data-kl-scroll-locking-modal']});
    closeUnrelatedPopup();
  }
  // Explicit scrolling also works when this preview is embedded in an app iframe.
  document.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
    const target=document.getElementById(link.getAttribute('href').slice(1));
    if(!target)return;
    event.preventDefault();
    target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }));
  const moments = {
    birthday: {title:'A birthday, made theirs.',copy:'Their favorite drawing, on a sugar-sheet cake decoration.',cta:'Make the next birthday theirs',alt:'A child and mother sharing a dinosaur birthday cake'},
    breakfast: {title:'A brighter good morning.',copy:'A pancake, a sunny drawing, and a message just for them.',cta:'Make mornings a little sweeter',alt:'A mother and child with a Good morning pancake at breakfast'},
    halloween: {title:'Spooky. Sweet. All yours.',copy:'Little ghosts and pumpkins for cookies, marshmallows, and muffins.',cta:'Make their treats a little spookier',alt:'A family making Halloween cookies and marshmallows'},
    lunch: {title:'A little love, packed in.',copy:'A heart and a few brave words on the outside of their lunchbox.',cta:'Send a little love with lunch',alt:'An encouragement note on the outside of a lunchbox'}
  };
  function setupTabs(selector, panelId, key, onChange) {
    const tabs = [...document.querySelectorAll(selector)];
    const panel = document.getElementById(panelId);
    function select(tab, focus = false) {
      tabs.forEach(item => { item.setAttribute('aria-selected', String(item===tab)); item.tabIndex = item===tab ? 0 : -1; });
      panel.setAttribute('aria-labelledby', tab.id);
      onChange(tab.dataset[key]);
      if (focus) tab.focus();
    }
    tabs.forEach((tab,index) => {
      tab.addEventListener('click',()=>select(tab));
      tab.addEventListener('keydown',event=>{
        let next;
        const vertical=tab.closest('[role="tablist"]').getAttribute('aria-orientation')==='vertical';
        if(event.key===(vertical?'ArrowDown':'ArrowRight'))next=(index+1)%tabs.length;
        if(event.key===(vertical?'ArrowUp':'ArrowLeft'))next=(index+tabs.length-1)%tabs.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=tabs.length-1;
        if(next!==undefined){event.preventDefault();select(tabs[next],true);}
      });
    });
  }
  setupTabs('[data-moment]','moment-panel','moment',key=>{
    const item=moments[key],photo=document.querySelector('.moment-photo');
    photo.dataset.scene=key;photo.setAttribute('aria-label',item.alt);
    document.querySelector('[data-moment-title]').textContent=item.title.toUpperCase();
    document.querySelector('[data-moment-copy]').textContent=item.copy;
    document.querySelector('[data-moment-cta]').textContent=item.cta;
  });
  const colors={green:{name:'Aurora Green',image:"https://cdn.shopify.com/s/files/1/0704/7767/6794/files/lQDPJw1D5qjk593NBXjNBXiwqQmlmAU9Z88ItW7npb3bAQ_1400_1400.jpg?v=1768269043"},black:{name:'Cosmic Black',image:"https://cdn.shopify.com/s/files/1/0704/7767/6794/files/lQDPJx_skVwmVavNBXjNBXiwWzPkIDjX69wI0cTisqF-AA_1400_1400.jpg?v=1768269043"},white:{name:'Pearl White',image:"https://cdn.shopify.com/s/files/1/0704/7767/6794/files/01-3_eb0c5274-7a7e-4cc0-8785-37b189f071b4.jpg?v=1768269043"}};
  const sets={
    first:{name:'First Moment Set',cartridges:1,variants:{green:'50189981384954',black:'50189981417722',white:'50189981450490'}},
    family:{name:'EdiBot Family Set',cartridges:1,variants:{green:'50189981483258',black:'50189981516026',white:'50189981548794'}},
    ready:{name:'Ready-to-Serve Set',cartridges:2,variants:{green:'50189981581562',black:'50189981614330',white:'50189981647098'}}
  };
  let productData={};
  try{productData=JSON.parse(document.getElementById('edibot-product-data').textContent);}catch(error){console.error('EdiBot product information could not be read.');}
  const liveVariants=new Map((Array.isArray(productData.variants)?productData.variants:[]).map(variant=>[String(variant.id),variant]));
  const currency=typeof productData.currency==='string'&&/^[A-Z]{3}$/.test(productData.currency)?productData.currency:'USD';
  const getVariant=(setKey,colorKey)=>liveVariants.get(sets[setKey].variants[colorKey]);
  const availableColor=setKey=>Object.keys(colors).find(key=>getVariant(setKey,key)?.available);
  const hasAvailableSet=()=>Object.keys(sets).some(key=>Boolean(availableColor(key)));
  let selectedSet=availableColor('family')?'family':Object.keys(sets).find(key=>Boolean(availableColor(key)))||'family';
  let selectedColor=getVariant(selectedSet,'green')?.available?'green':availableColor(selectedSet)||'green';
  const colorInputs=document.querySelectorAll('input[name="product-color"],input[name="quick-color"]');
  const setInputs=document.querySelectorAll('input[name="product-set"]');
  const quickSet=document.getElementById('quick-set');
  const money=cents=>Number.isFinite(Number(cents))?new Intl.NumberFormat('en-US',{style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(cents)/100):'Unavailable';
  const productLink=document.querySelector('[data-product-link]');
  function renderCardPrice(input){
    const key=input.value;
    const variant=getVariant(key,selectedColor)||getVariant(key,availableColor(key)||'green');
    const price=input.closest('.set-option').querySelector('.set-option-price');
    const parts=[document.createTextNode(variant?money(variant.price)+' ':'Unavailable')];
    if(variant){
      const unit=document.createElement('small');unit.textContent=currency;parts.push(unit);
      if(Number(variant.compare_at_price)>Number(variant.price)){
        const comparison=document.createElement('s');comparison.textContent=money(variant.compare_at_price);parts.push(document.createTextNode(' '),comparison);
      }
    }
    price.replaceChildren(...parts);
  }
  function renderSelection(){
    const set=sets[selectedSet],color=colors[selectedColor],variant=getVariant(selectedSet,selectedColor);
    const available=Boolean(variant?.available);
    colorInputs.forEach(input=>{
      input.checked=input.value===selectedColor;
      input.disabled=!getVariant(selectedSet,input.value)?.available;
      input.closest('label').title=input.disabled?colors[input.value].name+' — currently unavailable':colors[input.value].name;
    });
    setInputs.forEach(input=>{input.checked=input.value===selectedSet;input.disabled=!availableColor(input.value);renderCardPrice(input);});
    [...quickSet.options].forEach(option=>{option.disabled=!availableColor(option.value);});
    quickSet.value=selectedSet;
    document.querySelectorAll('[data-color-name]').forEach(el=>{el.textContent=color.name;});
    document.querySelectorAll('[data-set-name]').forEach(el=>{el.textContent=set.name;});
    document.querySelectorAll('[data-set-contents-title]').forEach(el=>{el.textContent=(set.name+' contents').toUpperCase();});
    document.querySelectorAll('[data-set-price]').forEach(el=>{el.textContent=variant?money(variant.price):'Unavailable';});
    document.querySelectorAll('[data-price-currency]').forEach(el=>{el.textContent=variant?currency:'';});
    document.querySelectorAll('[data-set-compare]').forEach(el=>{
      const show=variant&&Number(variant.compare_at_price)>Number(variant.price);
      el.hidden=!show;el.textContent=show?money(variant.compare_at_price):'';
    });
    document.querySelectorAll('[data-product-image]').forEach(img=>{img.src=color.image;img.alt=color.name+' Edibot Device and one Ink Pod; see the selected set contents for quantities';});
    const items=[['Edibot Device'],['Food-safe Ink Pod',set.cartridges+' included'],['HomeSpark Access'],['Sugar Sheet'],['Large-format Positioning Ruler']];
    document.querySelectorAll('[data-selected-box],[data-dialog-contents]').forEach(box=>{
      box.replaceChildren(...items.map(([title,description])=>{
        const li=document.createElement('li'),strong=document.createElement('strong');
        strong.textContent=title;li.append(strong);
        if(description){const span=document.createElement('span');span.textContent=description;li.append(span);}
        return li;
      }));
    });
    const care='Ink Care is free for the first 500 EdiBot customers · $49.99 value.';
    document.querySelectorAll('[data-set-service]').forEach(el=>{el.textContent=care;});
    document.querySelectorAll('[data-review-set]').forEach(button=>{
      button.disabled=!available;
      button.setAttribute('aria-disabled',String(!available));
      button.firstChild.textContent=available?'Buy now':variant?'Sold out':'Unavailable';
    });
    if(available){
      const url=new URL(productData.url||'/products/edibot-food-printer-sets',window.location.origin);
      url.searchParams.set('variant',String(variant.id));
      productLink.href=url.toString();
      productLink.removeAttribute('aria-disabled');productLink.removeAttribute('tabindex');
      productLink.firstChild.textContent='Shop this set ';
    }else{
      productLink.removeAttribute('href');productLink.setAttribute('aria-disabled','true');productLink.tabIndex=-1;
      productLink.firstChild.textContent=variant?'Sold out':'Currently unavailable';
    }
  }
  function selectSet(key){
    if(!sets[key]||!availableColor(key))return;
    selectedSet=key;
    if(!getVariant(key,selectedColor)?.available)selectedColor=availableColor(key);
    renderSelection();
  }
  colorInputs.forEach(input=>input.addEventListener('change',()=>{if(colors[input.value]&&getVariant(selectedSet,input.value)?.available){selectedColor=input.value;renderSelection();}}));
  setInputs.forEach(input=>input.addEventListener('change',()=>selectSet(input.value)));
  quickSet.addEventListener('change',()=>selectSet(quickSet.value));
  productLink.addEventListener('click',event=>{if(productLink.getAttribute('aria-disabled')==='true')event.preventDefault();});
  renderSelection();
  const setDialog=document.getElementById('set-dialog'),demoDialog=document.getElementById('demo-dialog'),video=demoDialog.querySelector('video');
  document.querySelectorAll('[data-review-set]').forEach(button=>button.addEventListener('click',()=>{if(hasAvailableSet())setDialog.showModal();}));
  document.querySelectorAll('[data-open-demo]').forEach(button=>button.addEventListener('click',()=>{
    demoDialog.showModal();
    video.play().catch(()=>{});
  }));
  demoDialog.addEventListener('close',()=>video.pause());
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
  video.addEventListener('error',()=>{document.querySelector('.video-error').hidden=false;});
  [setDialog,demoDialog].forEach(dialog=>dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  }));
})();
